__turbopack_context__.v({
  "legacyHeader": "EdgePortfolioTemplate-module__KS0AwG__legacyHeader",
  "moneyPostLayoutWrapper": "EdgePortfolioTemplate-module__KS0AwG__moneyPostLayoutWrapper",
  "wrapper": "EdgePortfolioTemplate-module__KS0AwG__wrapper",
});
